export const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Customer name",
  },
 
  {
    id: "mobileNumber",
    numeric: true,
    disablePadding: false,
    label: "Phone",
  },
  {
    id: "source",
    numeric: true,
    disablePadding: false,
    label: "Source",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "CreatedAt",
    numeric: true,
    disablePadding: false,
    label: "Created",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
  
];
export const Source = [
  { id: "whatsapp", name: "Whatsapp" },

  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "google", name: "Google" },
  { id: "walk-in", name: "Walk-In" },

  { id: "twitter", name: "Twitter" },
  { id: "linkedin", name: "Linkedin" },
  { id: "youtube", name: "Youtube" },
];


export const formatDate = (dateString) => {
  const date = new Date(dateString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${day}-${month}-${year} ${hours}${ampm}`;
};